import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './theme/a11y.css';
import './theme/mobile-typography.css';
import App from './App.js';

const promiseCtor = Promise as PromiseConstructor & {
	allSettled?: <T>(
		values: Iterable<T | PromiseLike<T>>,
	) => Promise<PromiseSettledResult<Awaited<T>>[]>;
};

if (typeof promiseCtor.allSettled !== 'function') {
	promiseCtor.allSettled = function allSettled<T>(
		values: Iterable<T | PromiseLike<T>>,
	): Promise<PromiseSettledResult<Awaited<T>>[]> {
		return Promise.all(
			Array.from(values, (value) =>
				Promise.resolve(value).then(
					(result) =>
						({
							status: 'fulfilled',
							value: result,
						}) as PromiseFulfilledResult<Awaited<T>>,
					(reason) =>
						({
							status: 'rejected',
							reason,
						}) as PromiseRejectedResult,
				),
			),
		);
	};
}

// 注：尝试过 ManagedMediaSource polyfill 让 iOS 18 用 flv.js（commit 472d7b8 已 revert）。
// flv.js 没适配 iOS 17.1+ ManagedMediaSource 的特殊要求（disableRemotePlayback、
// startstreaming/endstreaming 事件），polyfill 后所有视频解不出画面（含后厨）。
// 真要在 iPhone 上播 hflv 应该换 mpegts.js（原生支持 ManagedMediaSource）或
// 等 ulucu 服务端开 hls 输出（多数设备只发 hflv 不发 hls，hls m3u8 直接 404）。

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
);
